<mat-card>
  <h1>Bookmarks</h1>
  <h4>Sites I use often that I want quick access to</h4>
  <p class="bookmarks">
    <a *ngFor="let item of bookmarks" href="{{ item.url }}" target="_blank">
      <img src="{{ item.icon }}" height="32" />
    </a>
  </p>
  <h4>What Is This Site For?</h4>
  <p>I'm a computer programmer, and this is a personal site that I maintain mostly for my own use.  It contains a collection of small tools I've written that make programming a little easier.</p>
</mat-card>
